import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { ModelVehicleModel } from '@app/src/views/StepOne/form/models/modelVehicle';

export const modelVehicleService = {
  async get(vehicleId:number, brandId:number, modelName?: string): Promise<ModelVehicleModel[]> {
    try {
      let uri = process.env.API_VEHICLE_MODEL
        .replace(':vehicleId', '' + vehicleId)
        .replace(':brandId', '' + brandId);
      if (modelName) {
        uri = process.env.API_VEHICLE_MODEL_SEARCH
          .replace(':vehicleId', '' + vehicleId)
          .replace(':brandId', '' + brandId)
          .replace(':modelName', '' + modelName);
      }
      const { data } = await axiosAjax.get(uri);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
